import { DashboardFilter } from '../shared/models/dashboard-filter';
import { IncomeSummary } from '../shared/models';
import { DashboardService } from '../shared/services';
import { Component, Input, OnChanges, SimpleChange, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { RibbonMessageComponent } from '../../shared/ui';

@Component({
    selector: 'dashboard-summary',
    styles: [ require('./dashboard-summary.component.scss') ],
    template: require('./dashboard-summary.component.pug')
})
export class DashboardSummaryComponent implements OnChanges, OnDestroy {
    @ViewChild(RibbonMessageComponent) ribbonMessage;
    @Input() dashboardFilter: DashboardFilter;

    incomeSummary = new IncomeSummary(null);

    loading = true;
    authorized = true;

    errorMessage = 'Summary - Not Authorized';

    private _summarySubscription: Subscription;

    constructor(private _dashboardService: DashboardService) { }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        let dashboardFilter = changes['dashboardFilter'].currentValue;
        if (dashboardFilter) {
            this.loading = true;
            this._summarySubscription = this._dashboardService.getIncomeSummary(dashboardFilter)
                .subscribe(summary => this.incomeSummary = summary,
                           err => this._handleHttpError(err),
                           () => this.loading = false);
        };
    }

    ngOnDestroy() {
       // this._summarySubscription.unsubscribe();
    }

    private _handleHttpError(err: any) {
       if (err.status === 403) {
           this.authorized = false;
       }
       this.loading = false;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/summary/dashboard-summary.component.ts